/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deleteProfile} from '../api'

export const useMutationDeleteProfile = createReactQueryMutationHook('deleteProfile', deleteProfile)
